module.exports = __webpack_public_path__ + "media/images/certificado-titulo-f37f8d313c10a21deb568fc63537ce49.png";